export const requestStatus = {
  prepare: "0",
  success: "1",
  error: "99",
};
